import { WarnBannerComponent } from './warn-banner.component';

export const WarnBannerModule = angular
  .module('sfMobile.components.warn-banner', ['sfMobile.services.localization'])
  .component('sfWarnBanner', WarnBannerComponent).name;
